import { HStack, Text, VStack } from '@genial/components';
import React from 'react';

import { SecuritiesTransferDetailItemNormalized } from '../../../../../store/customerDetail/SecuritiesTransfer/types';

type GrossValueProps = Pick<SecuritiesTransferDetailItemNormalized, 'grossValueNormalized'>;

export const GrossValue: React.FC<GrossValueProps> = ({ grossValueNormalized }) => {
  return (
    <HStack flex={1} maxW="1/3" alignItems="center" justifyContent="flex-end">
      <VStack space="stack.nano">
        <Text variant="semibold">Valor bruto</Text>
        <Text>{grossValueNormalized}</Text>
      </VStack>
    </HStack>
  );
};
